<template>
  <section class="app-main custom-scroll">
    <transition name="fade-transform" mode="out-in">
      <div class="app-main-inner">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :key="key" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" :key="key" />
      </div>
      <!-- <keep-alive v-if="$route.meta.keepAlive">
        <router-view :key="key" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="key" /> -->
    </transition>
  </section>
</template>

<script>
  export default {
    name: 'AppMain',
    computed: {
      key() {
        return this.$route.path;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .app-main {
    /* 50= navbar  50  */
    // min-height: calc(100vh - 50px);
    width: 100%;
    height: 100%;
    // position: relative;
    // overflow-x: hidden;
    // overflow-y: auto;
    box-sizing: border-box;
  }

  .fixed-header + .app-main {
    padding-top: 50px;
    .app-main-inner {
      height: 100%;
      width: 100%;
      // position: relative;
      overflow-x: hidden;
      overflow-y: auto;
      box-sizing: border-box;

      > div {
        background: #fff;
        margin: 16px;
        min-height: 300px;
      }
    }
  }

  .hasTagsView {
    .app-main {
      /* 84 = navbar + tags-view = 50 + 34 */
      min-height: calc(100vh - 84px);
    }

    .fixed-header + .app-main {
      padding-top: 84px;
    }
  }
</style>

<style lang="scss">
  // fix css style bug in open el-dialog
  .el-popup-parent--hidden {
    // 这个*全局*样式影响到header修改密码dialog样式了，暂时去掉
    // .fixed-header {
    //   padding-right: 15px;
    // }
  }
</style>
